export const PAYMENT_LIST_LOADING = "PAYMENT_LIST_LOADING";
export const GET_PAYMENT_LIST = "GET_PAYMENT_LIST";
export const GET_PAYMENT_LIST_ERROR = "GET_PAYMENT_LIST_ERROR";

export const GET_PAYMENT_BY_ID_LOADING = "GET_PAYMENT_BY_ID_LOADING";
export const GET_PAYMENT_BY_ID_SUCCESS = "GET_PAYMENT_BY_ID_SUCCESS";
export const GET_PAYMENT_BY_ID_ERROR = "GET_PAYMENT_BY_ID_ERROR";